import React, {useEffect} from "react";
import TeacherGrid from "../../_components/teacher/TeacherGrid";
import ScheduleTable from "../../_components/teacher/ScheduleTable";
import "./ScheduleTeacherPage.sass"
import {useDispatch, useSelector} from "react-redux";
import {getGroups} from "../../_actions/group/groupService";
import {IDLE} from "../../common/statuses";

export default function ScheduleTeacherPage() {

    const {data: groups, status} = useSelector(state => state.groups.getGroups);

    const dispatch = useDispatch();

    useEffect(() => {
        if (status === IDLE) {
            dispatch(getGroups())
        }
    }, [status, dispatch]);
    useEffect(() => {
        document.title = 'КьюАй - Расписание и группы'
    }, [])

    return (
        <div className="schedule-teacher-wrapper">
            <TeacherGrid/>
            <ScheduleTable data={groups}/>
        </div>
    )
}